var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "discipline-amount-cell",
      class: {
        "discipline-amount-cell-red": _vm.record.is.value === "Штраф",
        "discipline-amount-cell-green": _vm.record.is.value === "Премия",
      },
    },
    [
      _vm.record.isFined == 1
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Штраф увеличен",
                  placement: "top",
                },
                expression:
                  "{ container: '#app', trigger: 'hover blur', content: 'Штраф увеличен', placement: 'top' }",
                modifiers: { html: true },
              },
            ],
            staticClass: "discipline-amount-cell-up",
            attrs: { icon: "up", size: "iconic" },
          })
        : _c("div"),
      _c("span", [
        _vm._v(_vm._s(_vm.formatAmount(_vm.record.summ.value) || 0)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }